// src/auth/RegisterPage.js
import React from 'react';
import './Auth.css';

const RegisterPage = () => {
  const handleGoogleSignup = () => {
    window.location.href = '/api/auth/login/google';
  };

  return (
    <div className="auth-container">
      <div className="auth-grid">
        {/* Left: Brand/hero */}
        <section className="auth-hero" aria-label="Clairifi overview">
          <div className="auth-hero-badge">Create your account</div>
          <h1 className="auth-hero-title">
            Get started with <span className="brand-accent">Clairifi</span>
          </h1>
          <p className="auth-hero-subtitle">
            One login for forecasting, insights, and strategy. Designed for modern finance teams.
          </p>
          <ul className="auth-hero-points">
            <li><span className="check-icon" aria-hidden>✓</span> Free trial — no credit card</li>
            <li><span className="check-icon" aria-hidden>✓</span> Secure Google sign-in</li>
            <li><span className="check-icon" aria-hidden>✓</span> Cancel anytime</li>
          </ul>
        </section>

        {/* Right: Auth card */}
        <section className="auth-card" aria-label="Registration form">
          <h2 className="auth-card-title">Create your Clairifi account</h2>
          <button onClick={handleGoogleSignup} className="auth-google-btn" aria-label="Continue with Google">
            <span className="google-icon" aria-hidden>
              <svg width="18" height="18" viewBox="0 0 48 48" focusable="false" aria-hidden="true">
                <path fill="#EA4335" d="M24 9.5c3.7 0 7 1.3 9.6 3.8l7.2-7.2C36.9 1.7 30.8-.3 24-.3 14.6-.3 6.4 5.1 2.5 13l8.8 6.8C13 14 18.1 9.5 24 9.5z"/>
                <path fill="#34A853" d="M46.1 24.5c0-1.6-.1-2.7-.4-3.9H24v7.4h12.7c-.5 3-2.2 5.6-4.8 7.3l7.3 5.6c4.3-4 7-9.8 7-16.4z"/>
                <path fill="#4A90E2" d="M24 47.7c6 0 11-2 14.6-5.3l-7.3-5.6c-2 1.3-4.7 2.1-7.3 2.1-5.9 0-11-4.5-12.7-10.6l-8.8 6.8C6.4 42.9 14.6 47.7 24 47.7z"/>
                <path fill="#FBBC05" d="M11.3 28.3C10.9 27 10.7 25.8 10.7 24.5s.2-2.5.6-3.8l-8.8-6.8C.8 16.3 0 20.3 0 24.5s.8 8.2 2.5 10.6l8.8-6.8z"/>
              </svg>
            </span>
            Continue with Google
          </button>
          <p className="auth-legal">
            By continuing you agree to our <a href="/terms">Terms</a> and <a href="/privacy">Privacy</a>.
          </p>
          <p className="auth-note">You’ll pick a plan later in the app.</p>
        </section>
      </div>
    </div>
  );
};

export default RegisterPage;
